import { Stack } from '@mui/system';
import React from 'react';
import { Container, ListGroup, Form } from 'react-bootstrap';

const ParentTagsScreen = ({
	selectedParent,
	returnedTags,
	selectParentTag,
	header,
	checked,
}) => {
	return (
		<Container>
			<div
				className={`parent_tag`}
				style={{
					marginLeft: '75px',
					marginTop: '-78px',
				}}
			>
				<div
					style={{
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'center',
					}}
				>
					<div className='tag-header1'>
						<h6>{header}</h6>
					</div>
				</div>

				<div className='rounded-pill p-2'>
					<div
						className='overflow-auto'
						style={{ maxHeight: '345px', padding: '0px', width: '260px' }}
					>
						{returnedTags?.length < 1 ? (
							<p>No tags available.</p>
						) : (
							<ListGroup>
								{selectedParent?.length <= 0
									? returnedTags.map(d1 => (
											<ListGroup.Item className='tag ms-2' key={d1.value}>
												<Stack
													direction='row'
													justifyContent='space-between'
													alignItems='center'
													spacing={2}
												>
													{d1.label}{' '}
													<Form.Check
														type='checkbox'
														id={d1.value}
														label=''
														checked={checked.includes(d1.value)}
														value={JSON.stringify(d1)}
														onChange={e => selectParentTag(e, d1)}
													/>
												</Stack>
											</ListGroup.Item>
									  ))
									: selectedParent.map(d1 => (
											<ListGroup.Item
												className='tag ms-2 selected-parent'
												style={{ padding: '7px', height: '63px' }}
												key={d1.value}
											>
												<Stack
													direction='row'
													justifyContent='space-between'
													alignItems='center'
													spacing={2}
												>
													{d1.label}{' '}
													<Form.Check
														type='checkbox'
														id={d1.value}
														label=''
														checked={checked.includes(d1.value)}
														value={JSON.stringify(d1)}
														onChange={e => selectParentTag(e, d1)}
													/>
												</Stack>
											</ListGroup.Item>
									  ))}
							</ListGroup>
						)}
					</div>
				</div>
			</div>
		</Container>
	);
};

export default ParentTagsScreen;
